import type { FunctionComponent } from "react";

import classNames from "classnames";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import {
    FeatureRowResultCellContainer,
    FeatureRowResultCellIcon,
    FeatureRowResultCellLeftSideContainer,
    FeatureRowResultCellText,
    SERPSnapshotResultCellWrapper,
    StyledEnrichButton,
    StyledUrlCell,
    UrlTitle,
} from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/StyledComponents";
import type { SERPSnapshotCellProps } from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/types";
import { ESERPMetaType } from "app/pages/keyword-research/keyword-analysis/pages/serp-snapshot/types";
import { UrlCell } from "app/components/React/Table/cells";
import { i18nFilter } from "app/filters/i18nFilter";
import { SERP_MAP } from "app/pages/website-analysis/traffic-sources/search/components/serp/SerpTypes";

export const SERPSnapshotResultCell: FunctionComponent<SERPSnapshotCellProps> = (props) => {
    const { value, row, onCellClick, hideUrl } = props;
    const onClick = (e: Event) => {
        e.stopPropagation();
        onCellClick(e, row?.index);
    };
    //for future use to see the enrich rows
    if (row.type === ESERPMetaType.FEATURE) {
        const { icon, name } = SERP_MAP[row.serpFeature];
        return (
            <FeatureRowResultCellContainer
                justifyContent="space-between"
                alignItems="center"
            >
                <FeatureRowResultCellLeftSideContainer
                    justifyContent="flex-start"
                    alignItems="center"
                >
                    <FeatureRowResultCellIcon
                        iconName={icon}
                        size="xs"
                    />
                    <FeatureRowResultCellText>{name}</FeatureRowResultCellText>
                </FeatureRowResultCellLeftSideContainer>
                <StyledEnrichButton
                    height={24}
                    onClick={onClick}
                    className={classNames("enrich")}
                    iconName={"chev-down"}
                >
                    <Text
                        as="div"
                        fontVariant="drilldown"
                        color={colorsPalettes.carbon[0]}
                    >
                        {i18nFilter()("keyword.research.serp.snapshot.table.enrich.button.title")}
                    </Text>
                </StyledEnrichButton>
            </FeatureRowResultCellContainer>
        );
    } else {
        return (
            <SERPSnapshotResultCellWrapper alignItems="flex-start">
                {row.title ? <UrlTitle>{row.title}</UrlTitle> : <div>-</div>}
                {!hideUrl ? (
                    value ? (
                        <StyledUrlCell>
                            <UrlCell site={value} />
                        </StyledUrlCell>
                    ) : (
                        <div>-</div>
                    )
                ) : null}
            </SERPSnapshotResultCellWrapper>
        );
    }
};
